import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';
import { GET_LIVE_CONTEXT_STATE_QUERY_KEY } from '@/state/queries/player/use-get-live-context-state';

export type MicAudibleOverrideMode = 'segment' | 'permanent';

export interface ToggleLayerAudibleRequest {
  entityRef: string;
  itemId: string;
  mode?: MicAudibleOverrideMode;
  audible?: boolean;
  clearOverride?: boolean;
}

export interface ToggleLayerAudibleResponse {
  audible: boolean;
  mode?: MicAudibleOverrideMode | 'default';
}

export const useToggleLayerAudibleMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: ToggleLayerAudibleRequest) => {
      const token = await getToken();
      return toggleLayerAudible(body, token ?? '');
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [GET_LIVE_CONTEXT_STATE_QUERY_KEY, variables.entityRef],
      });
    },
  });
};

const toggleLayerAudible = async (
  body: ToggleLayerAudibleRequest,
  token: string,
): Promise<ToggleLayerAudibleResponse> => {
  const url = `${import.meta.env.VITE_API_URL}/player/live-context-state/toggle-layer-audible`;
  return sendJSONRequest({ url, method: METHOD.POST, body, token });
};
